import MarketingPreferencesInfo from './MarketingPreferencesInfo';

export default MarketingPreferencesInfo;
